import { calculateDifference } from '@app/utils/filter/terms/calculate-difference';
import { Value } from '@app/utils/filter/terms/value';

export type LessThan = {
  arguments: [Value];
  key: string;
  operator: 'lt';
};

export const lessThan = function (value: any, upperBound: Value): boolean {
  return calculateDifference(value, upperBound) > 0;
};
